import { render, staticRenderFns } from "./ServiceVersionList.vue?vue&type=template&id=a1d88142&scoped=true"
import script from "./ServiceVersionList.vue?vue&type=script&lang=js"
export * from "./ServiceVersionList.vue?vue&type=script&lang=js"
import style0 from "./ServiceVersionList.vue?vue&type=style&index=0&id=a1d88142&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1d88142",
  null
  
)

export default component.exports